import { Box, Typography, useTheme } from "@mui/material";
import { BusinessCheckoutTabs } from "lib/features/businessList/types";
import { businessCheckout } from "styles/Checkout/multiBusinessCheckout";

interface CheckoutToggleProps {
  activeTab: string;
  setActiveTab: (option: string) => void;
}

const CheckoutToggle = ({ activeTab, setActiveTab }: CheckoutToggleProps) => {

  const theme = useTheme();

  return (
    <Box sx={businessCheckout.toggleContainer}>
      <Typography
        sx={
          activeTab === BusinessCheckoutTabs.BookableItems
            ? businessCheckout.activeText(theme)
            : businessCheckout.inAciveText(theme)
        }
        onClick={() => setActiveTab(BusinessCheckoutTabs.BookableItems)}
      >
        {BusinessCheckoutTabs.BookableItems}
      </Typography>
      <Typography
        sx={
          activeTab === BusinessCheckoutTabs.Businesses
            ? businessCheckout.activeText(theme)
            : businessCheckout.inAciveText(theme)
        }
        onClick={() => setActiveTab(BusinessCheckoutTabs.Businesses)}
      >
        {BusinessCheckoutTabs.Businesses}
      </Typography>
    </Box>
  );
};

export default CheckoutToggle;
